import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _EmployeeByFunctional } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../../theme/Component/usePaginator";


interface Props {
    IDLn: number;
}

export const EmployeeByFunctional = ({ IDLn }: Props) => {

    const employeefunctional = useDataBean(_EmployeeByFunctional);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    useEffect(() => {
        getLista();
    }, [IDLn, paginador.page])

    const getLista = () => {

        employeefunctional.instance.getEmployeeContractsByFunctionalArea(IDLn, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }


    const create = () => {
        employeefunctional.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {


    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        employeefunctional.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'IDContrato', property: 'IDContract', visible: true, mask: MASK_NUMBER },
        { title: 'Usuario', property: 'AccountName', visible: true, mask: MASK_TEXT_NOWRAP },
        // { title: 'Perfil de Liquidación', property: 'IDEmployeeLiquidate', visible: true },
        { title: 'Nivel Jerárquico', property: 'EntailmentName', visible: true },
        { title: 'Nivel Salarial/Grado', property: 'AppointmentName', visible: true },
        { title: 'Tipo Vinculación', property: 'ContractTypeName', visible: true },
        { title: 'ID Plaza Laboral', property: 'IDLnFunctionalArea', mask: MASK_NUMBER, visible: true },
        { title: 'Plaza Laboral', property: 'FunctionalAreaName', visible: true },
        { title: 'Código Posición Jerárquica', property: 'FunctionalIDJsonCode', visible: true },
        { title: 'Nombre Posición Jerárquica', property: 'FunctionalIDName', visible: true },
        { title: 'Fecha de Inicio', property: 'InitContract', mask: MASK_DATE, visible: true },
        { title: 'Ingreso Nación', property: 'NationInit', mask: MASK_DATE, visible: true },
        // { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        // { title: 'Tipo de Payrol', property: 'PayrollTypeName', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
        { title: 'EPS', property: 'EPSName', visible: true },
        { title: 'ARP', property: 'ARPName', visible: true },
        { title: 'CCF', property: 'CCFName', visible: true },
        { title: 'Fondo Pensional', property: 'FPName', visible: true },
        { title: 'Fondo Cesantías', property: 'FCEName', visible: true },
        { title: 'Tipo de Salario', property: 'RevenueType', visible: true },
        { title: 'Salario', property: 'Revenue', mask: MASK_MONEY, visible: true },
        { title: 'Usar Salario Definido en el Contrato', property: 'UseContractSalaryValue', visible: true },
        { title: 'Salario Definido por Contrato', property: 'ContractSalaryValue', mask: MASK_MONEY, visible: true },
        { title: 'Tipo Riesgo', property: 'ARPRiskName', visible: true },
        { title: 'Tipo Cotizante', property: 'EmployeeTypeName', visible: true },
        { title: 'Subtipo Cotizante', property: 'EmployeeSubtypeName', visible: true },
        { title: 'Fecha Renuncia', property: 'EndingDate', mask: MASK_DATE, visible: true },
        { title: 'Estado', property: 'ContractStateName', visible: true },
        { title: 'Fecha Liquidación', property: 'UptoContract', mask: MASK_DATE, visible: true },
        { title: 'Fecha de Nacimiento', property: 'BornDate', mask: MASK_DATE, visible: true },
        { title: 'Dirección', property: 'Address', mask: MASK_TEXT_NOWRAP, visible: true },
        { title: 'Teléfono', property: 'Tel', visible: true },
        { title: 'Correo Electrónico', property: 'eMail', visible: true },
        { title: 'Género', property: 'GenType', visible: true },
        { title: 'Resposable ImpoRenta', property: 'RentTax', visible: true },
        { title: 'Último Exámen Médico', property: 'HealthTestDate', mask: MASK_DATE, visible: true },
        { title: 'Últimas Vacaciones', property: 'LastVacDate', mask: MASK_DATE, visible: true },
        { title: 'Última Dotación', property: 'LastEndowmentDate', mask: MASK_DATE, visible: true },
        { title: 'Tipo de Empleo', property: 'EmploymentTypeName', visible: true },
        { title: 'Código CIIU', property: 'CIIUCode', mask: MASK_NUMBER, visible: true },
        { title: 'Subtipo ARL', property: 'ARPRiskName', visible: true },
        { title: 'Tipo de Contrato', property: 'EmployeeContractType', visible: true },
        { title: 'Definir Límite de UVTs', property: 'UseUVTMaxRetefuente', visible: true },
        { title: 'Limite UVTs', property: 'UVTMaxRetefuente', visible: true },
        { title: 'Ciudad de Ejecución del Contrato', property: 'SiteIDName', visible: true },
        { title: 'Creado por', property: 'EmployeeName', visible: true },
        { title: 'Actualizado por', property: 'LastUpdateEmployeeName', visible: true },
        { title: 'Método de Cálculo', property: 'IDTaxRetentionMethodName', visible: true },
        { title: '% Fijo de Retención para el Procedimiento 2', property: 'TaxRetentionPercent2', visible: true },
        { title: 'Fecha Última Actualización', property: 'LastUpdate', visible: true, mask: MASK_DATE },
        { title: 'Unidad de Negocio', property: 'BusinessCoreCode', visible: true },
        { title: 'Definir Centro de Costo', property: 'UseOwnCostingCenter', visible: true },
        { title: 'Centro de Costo', property: 'CostingCenterName', visible: true },
        { title: 'Utilizar Tipo de Payroll', property: 'UsePayrollType', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={employeefunctional.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">

                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}